<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary ml-1">MY INVITE</h2></a
    >
    <!-- /Brand logo-->
    <!-- Left Text-->
    
    <!-- /Left Text-->
    <!-- Login-->
    <div class="d-flex col-lg-12 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1 text-center">مرحبا بك في MY INVITE! 👋</h2>
        <p class="card-text mb-2 text-center">الرجاء تسجيل الدخول إلى حسابك</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>

        <form class="auth-login-form mt-2" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label class="form-label" for="login-email">البريد الالكتروني او رقم الهاتف</label>
            <input
              type="text"
              formControlName="userNameOrPhoneNumber"
              class="form-control"
              placeholder="برجاء ادخال البريد الالكتروني او رقم الهاتف"
              aria-describedby="login-email"
              autofocus=""
              tabindex="1"
            />
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <label for="login-password">كلمة المرور</label>
              <!-- <a routerLink="/pages/authentication/forgot-password-v2"><small>هل نسيت كلمة المرور؟</small></a> -->
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                class="form-control form-control-merge"
                placeholder="برجاء ادخال كلمة المرور"
                aria-describedby="login-password"
                tabindex="2"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                  ><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3" />
              <label class="custom-control-label" for="remember-me"> تذكرني</label>
            </div>
          </div>
          <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>تسجيل الدخول
          </button>
        </form>
        <!-- <p class="text-center mt-2">
          <span>New on our platform?</span
          ><a routerLink="/pages/authentication/register-v2"><span>&nbsp;Create an account</span></a>
        </p> -->
        <!-- <div class="divider my-2">
          <div class="divider-text">or</div>
        </div> -->
        <!-- <div class="auth-footer-btn d-flex justify-content-center">
          <a class="btn btn-facebook" href="javascript:void(0)"><i data-feather="facebook"></i></a
          ><a class="btn btn-twitter white" href="javascript:void(0)"><i data-feather="twitter"></i></a
          ><a class="btn btn-google" href="javascript:void(0)"><i data-feather="mail"></i></a
          ><a class="btn btn-github" href="javascript:void(0)" title="إجراء"><i data-feather="github"></i></a>
        </div> -->
      </div>
    </div>
    <!-- /Login-->
  </div>
</div>

<div class="custom-alert" [class.show]="showAlert" [class.hide]="!showAlert" dir="ltr">
  <span *ngIf="successOrError" style="color: #3F8260;">{{msg}} <i data-feather="check" class="mr-50"></i> </span>
  <span *ngIf="!successOrError" style="color: #f07163;">{{msg}} <i data-feather="alert-triangle" class="mr-50"></i> </span>
</div>
